import { DataApiResponse } from "./DataApiResponse";


export interface SearchApiResponse<T> {
  result: DataApiResponse<T>;
  term: string;
}
